const initialState = {
  calendar: null,
  selectedCalendar: null,
  boards: {}
}
const home = (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_BOARDS': 
      let home = state
      action.snapshot.docs.forEach(doc => {
        if(doc.id === "calendar"){
          home.calendar = doc.data()
        }else{
          home.boards[doc.id] = doc.data()
        }
      })
      if(!home.selectedCalendar){
        home.selectedCalendar = Object.keys(home.calendar)[0]
      }
      return home
    
    case 'CHANGE_CALENDAR':
      return {
        ...state,
        selectedCalendar: action.calendar
      }

    default: 
      return state
  }
}
export default home


// WEBPACK FOOTER //
// ./src/reducers/home.js